import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { useAuth } from '../../contexts/Auth';
import { currentProjectState } from '../../recoil/project';

export default function PrivateOutlet() {
    const { isLoggedIn } = useAuth();
    const location = useLocation();
    const currentProject = useRecoilValue(currentProjectState);

    if (!isLoggedIn) {
        return <Navigate to="/auth/login" />;
    }

    // Allow /projects to be shown if user explicitly navigated there (e.g., clicked home icon)
    const showProjectsList = (location.state as any)?.showProjectsList === true;

    // Redirect to project if we're on root or projects list and have a valid project
    // But don't redirect if user explicitly wants to see the projects list
    if (
        ["/", "/projects", "/projects/"].includes(location.pathname) &&
        currentProject?.id &&
        !showProjectsList
    ) {
        return <Navigate to={`/projects/${currentProject.id}/environments`} replace />;
    }

    return <Outlet />;
}